module.exports = __webpack_public_path__ + "img/3a.42699f94.jpg";